function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#348C30;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M191.1,302.7c0-10.3,8.4-18.6,18.6-18.6s18.6,8.4,18.6,18.6v98.8c11.6,5.5,24.1,9.2,37.3,11v-75.3 c0-10.3,8.4-18.6,18.6-18.6s18.6,8.4,18.6,18.6v75.1c13.2-2,25.7-6,37.3-11.6V246.9c0-10.3,8.4-18.6,18.6-18.6s18.6,8.4,18.6,18.6 v126.4c22-23.3,35.6-54.6,35.6-89.2c0-71.6-58.1-129.7-129.7-129.7s-129.7,58.1-129.7,129.7c0,35.5,14.2,67.6,37.3,91L191.1,302.7 L191.1,302.7z"
});

var SvgOxyContabil = function SvgOxyContabil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxyContabil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-contabil.5d177867.svg";
export { ForwardRef as ReactComponent };